import * as React from "react";
import { Button } from "antd";

interface ISubmitButtonProps {
  submitTitle?: string;
  resetTitle?: string;
  linkTitle?: string;
  extraTitle?: string;
  submitClick?: any;
  resetClick?: any;
  linkClick?: any;
  extraClick?: any;
}

// 表单提交按钮组

class SubmitButton extends React.Component<ISubmitButtonProps, any> {
  constructor(props: ISubmitButtonProps) {
    super(props);
  }

  iconStyle = {
    display: "inline-block",
    color: "#2b9fbd",
    marginRight: 4,
    fontSize: 14
  };

  // 按钮的样式
  buttonStyle(color, otherStyle = {}) {
    return {
      width: 120,
      backgroundColor: color,
      borderColor: color,
      ...otherStyle
    };
  }

  render() {
    return (
      <div className="submit-button">
        <Button
          type="primary"
          onClick={this.props.submitClick || null}
          style={this.buttonStyle("#0B9937")}
        >
          {this.props.submitTitle || "搜索（Enter）"}
        </Button>
        <Button
          type="primary"
          onClick={this.props.resetClick || null}
          style={this.buttonStyle("#9E9463", { marginLeft: 10 })}
        >
          {this.props.resetTitle || "重置（Delete）"}
        </Button>
        {
          this.props.extraTitle ?
          <Button
          type="primary"
          onClick={this.props.extraClick || null}
          style={this.buttonStyle("#329FBB", { marginLeft: 10 })}
        >
          {this.props.extraTitle || "创建定制单"}
        </Button>
          : <a
          onClick={this.props.linkClick}
          style={{ marginLeft: 10, fontSize: 12, color: "#2b9fbd" }}
          >
            {this.props.linkTitle != '  ' && <i className="action-user action-bianji" style={this.iconStyle} />}
            {this.props.linkTitle || "隐藏搜索面板"}
          </a>

        }

        
      </div>
    );
  }
}

export default SubmitButton;
